import request from '@/utils/request';

/*
* 农产品加工补贴
* */

// 申报通知列表
export function getDeclarationNoticeList(data = {}) {
  return request({
    url: '/special/agricultural/user/list',
    method: 'POST',
    data: { ...data, status: 1 },
  });
}

// 申报通知-详情
export function getDeclarationNoticeDetail(id) {
  return request({
    url: '/special/agricultural/detail',
    method: 'GET',
    params: { id },
  });
}

// 申报申请
export function addApply(data) {
  return request({
    url: '/special/agricultural/application/add',
    method: 'POST',
    data,
  });
}

// 重新申请
export function editApply(data) {
  return request({
    url: '/special/agricultural/application/edit',
    method: 'POST',
    data,
  });
}

// 我的申请-详情
export function getDeclarationData(id) {
  return request({
    url: '/special/agricultural/application/detail',
    method: 'GET',
    params: { id, type: 1 },
  });
}

// 公示列表查询
export function getAgriculturalPublicList(data) {
  return request({
    url: '/special/agricultural/manage/user/release/publish',
    method: 'POST',
    data: { ...data },
  });
}

// 获取-建设类容
export function getSpecialContentData(id) {
  return request({
    url: '/special/agricultural/application/specialContent',
    method: 'GET',
    params: { id },
  });
}
